import apiClient from "../config/apiClient";

export const resetPassword = async (data) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.post(`/public/portal?url=auth/patient/password/reset`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

// 27503


